// this is needed by and old "buffer" version. Remove after the dependency is updated
globalThis.global ||= globalThis;
